import R from 'ramda';
import _ from 'lodash';
import React, { Component } from 'react';
import { connect } from 'react-redux';
import {
  Modal,
  Col,
  Row,
  Form,
  FormGroup,
  FormControl,
  ControlLabel,
  Checkbox,
  Button,
  OverlayTrigger,
  Tooltip,
} from 'react-bootstrap';
import Select from 'react-select';
import actions from '../../redux/actions';
import { getRoleIds } from '../../utils';
import AvatarUploader from '../AvatarUploader';

class CreateMember extends Component {
  constructor(props) {
    super(props);

    this.state = {
      avatar: '',
      useCompanyName: false,
      companyName: '',
      userTitle: '',
      roleIds: [],
      roleOptions: [],
      ownershipTypes: [],
      memberName: '',
      memberEmail: '',
      canCreateOwnMember: false,
      memberOwnership: '',
    };
  }

  opened() {
    let { type, fields, roles, ownershipTypes, profile, members } = this.props;

    if (type === 'create') {
      roles = R.filter(
        (role) => fields.type && fields.type === parseInt(role.work_type, 10),
        roles
      );
      ownershipTypes = R.filter(
        (o) =>
          !o.work_type ||
          (fields.type && fields.type === parseInt(o.work_type, 10)),
        ownershipTypes
      );
    }
    roles = R.uniqBy(R.prop('title'), R.sortBy(R.prop('title'), roles));

    let roleOptions = [];
    roles.forEach((role) => {
      roleOptions.push({ value: role.id, label: role.title });
    });

    let canCreateOwnMember =
      _.findIndex(
        members,
        (member) => member.user_info.email === profile.email
      ) === -1;
    if (profile.subscription_plan === 'pro-annual') {
      canCreateOwnMember = false;
    }

    this.setState({
      ownershipTypes,
      roleOptions,
      memberName: canCreateOwnMember ? profile.name : '',
      memberEmail: canCreateOwnMember ? profile.email : '',
      avatar: canCreateOwnMember ? profile.avatar : '',
      useCompanyName: canCreateOwnMember ? profile.use_company_name : false,
      companyName: canCreateOwnMember ? profile.company_name : '',
      userTitle: canCreateOwnMember ? profile.user_title : '',
      canCreateOwnMember,
      roleIds: [],
    });
  }

  close() {
    this.props.onClose();
  }

  save(e) {
    e.preventDefault();
    const { members } = this.props;

    if (
      _.find(
        members,
        (member) =>
          member.user_info.email.toLowerCase() ===
          this.state.memberEmail.toLowerCase()
      )
    ) {
      this.props.alert(
        'error',
        'You have already added this person to your team.'
      );
      return;
    }

    this.props.hideAlert();

    const ownership_type_id = this.state.memberOwnership;

    if (this.state.roleIds.length === 0) {
      this.props.alert('error', "Please select member's role.");
    } else if (!ownership_type_id) {
      this.props.alert('error', "Please select member's ownership type.");
    } else {
      let data = {
        name: this.state.memberName,
        email: this.state.memberEmail,
        role_ids: this.state.roleIds,
        ownership_type_id: ownership_type_id,
        avatar: this.state.avatar,
        company_name: this.state.companyName,
        user_title: this.state.userTitle,
        use_company_name: this.state.useCompanyName,
      };

      this.props.onSave(data);
      this.close();
    }
  }

  handleUpload(file) {
    if (file && file.url) {
      this.setState({ avatar: file.url });
    } else {
      this.setState({ avatar: '' });
    }
  }

  handleCheck = (e) => {
    this.props.hideAlert();
    this.setState({ useCompanyName: e.target.checked });
  };

  handleChange = (e) => {
    this.props.hideAlert();
    this.setState({ [e.target.getAttribute('id')]: e.target.value });
  };

  handleSelectChange = (options) => {
    this.setState({ roleIds: getRoleIds(options) });
  };

  render() {
    const {
      roleOptions,
      ownershipTypes,
      canCreateOwnMember,
      avatar,
      memberName,
      memberEmail,
      memberOwnership,
    } = this.state;

    return (
      <Modal
        className="create-member-modal"
        show={this.props.open}
        onEnter={() => this.opened()}
        onHide={() => this.close()}
      >
        <Form onSubmit={(e) => this.save(e)}>
          <Modal.Header closeButton>
            <Modal.Title>
              {canCreateOwnMember
                ? 'First, let’s add you to this team'
                : 'New Collaborator'}
            </Modal.Title>
          </Modal.Header>

          <Modal.Body>
            <Row className="mb4">
              <Col md={3}>
                <div className="member-photo text-center upload-photo">
                  <AvatarUploader
                    size="100"
                    readOnly={canCreateOwnMember}
                    image={avatar}
                    onUpload={(file) => this.handleUpload(file)}
                  >
                    <span className="text-gray btn-upload-photo">
                      Add a picture
                    </span>
                  </AvatarUploader>
                </div>
              </Col>
              <Col md={9}>
                <div className="member-name">
                  <OverlayTrigger
                    overlay={
                      <Tooltip id="tooltip-name">
                        Please provide this collaborator's full legal name.
                      </Tooltip>
                    }
                    placement="right"
                  >
                    <FormGroup>
                      <FormControl
                        type="text"
                        id="memberName"
                        placeholder="Collaborator's full legal name"
                        required
                        value={memberName}
                        onChange={this.handleChange}
                        disabled={canCreateOwnMember}
                      />
                    </FormGroup>
                  </OverlayTrigger>
                  <FormGroup>
                    <FormControl
                      type="email"
                      id="memberEmail"
                      placeholder="Collaborator's email address"
                      required
                      value={memberEmail}
                      onChange={this.handleChange}
                      disabled={canCreateOwnMember}
                    />
                  </FormGroup>
                  <OverlayTrigger
                    placement="right"
                    overlay={
                      <Tooltip id="tooltip-company-name">
                        To be able to sign your agreement on behalf of your
                        company, go to your profile settings and check the box
                        marked "I will sign on behalf of a company.
                      </Tooltip>
                    }
                  >
                    <FormGroup>
                      <Checkbox
                        onChange={this.handleCheck}
                        checked={this.state.useCompanyName}
                        disabled={canCreateOwnMember}
                      >
                        This collaborator will sign on behalf of a company.
                      </Checkbox>
                    </FormGroup>
                  </OverlayTrigger>
                  {this.state.useCompanyName && (
                    <OverlayTrigger
                      placement="right"
                      overlay={
                        <Tooltip id="tooltip-company-name">
                          If this collaborator already has a Cosynd account,
                          they will need to fill in their company name, title,
                          and check the box marked “I will sign on behalf of a
                          company” in their profile before you create this team.
                        </Tooltip>
                      }
                    >
                      <FormGroup controlId="companyName">
                        <FormControl
                          type="text"
                          id="companyName"
                          placeholder="Company name"
                          value={this.state.companyName}
                          onChange={this.handleChange}
                          disabled={canCreateOwnMember}
                        />
                      </FormGroup>
                    </OverlayTrigger>
                  )}
                  {this.state.useCompanyName && (
                    <OverlayTrigger
                      placement="right"
                      overlay={
                        <Tooltip id="tooltip-user-title">
                          If this collaborator already has a Cosynd account,
                          they will need to fill in their company name, title,
                          and check the box marked “I will sign on behalf of a
                          company” in their profile before you create this team.
                        </Tooltip>
                      }
                    >
                      <FormGroup>
                        <FormControl
                          type="text"
                          id="userTitle"
                          placeholder="Collaborator's title"
                          value={this.state.userTitle}
                          onChange={this.handleChange}
                          disabled={canCreateOwnMember}
                        />
                      </FormGroup>
                    </OverlayTrigger>
                  )}
                </div>
              </Col>
            </Row>
            <OverlayTrigger
              overlay={
                <Tooltip id="tooltip-role">
                  Please select the role this collaborator played in creating
                  this work.
                </Tooltip>
              }
              placement="right"
            >
              <FormGroup controlId="member-role">
                <ControlLabel>What is this collaborator's role?</ControlLabel>
                <Select
                  isMulti
                  options={roleOptions}
                  placeholder="Select role(s)"
                  onChange={this.handleSelectChange}
                />
                {/* <p>You can select multiple roles</p>
                <FormControl ref="memberRole" componentClass="select" id="member-role" size="6" multiple>
                  {roles && roles.map((role, i) => (
                    <option key={i} value={role.id}>{role.title}</option>
                  ))}
                </FormControl> */}
              </FormGroup>
            </OverlayTrigger>
            {/* <OverlayTrigger overlay={(<Tooltip id="tooltip-default-role">Plan on creating more content with this person? Check this box to automatically assign this role to them for future agreements (you can always change their role later).</Tooltip>)} placement="right">
              <FormGroup>
                <Checkbox ref="defaultRole">
                  Make this the default role for this collaborator
                </Checkbox>
              </FormGroup>
            </OverlayTrigger> */}
            <FormGroup>
              <ControlLabel>What does this collaborator own?</ControlLabel>
              <FormControl
                componentClass="select"
                id="memberOwnership"
                size="3"
                value={memberOwnership.toString()}
                onChange={this.handleChange}
              >
                {ownershipTypes &&
                  ownershipTypes.map((ownershipType, i) => (
                    <option key={i} value={ownershipType.id}>
                      {ownershipType.name}
                    </option>
                  ))}
              </FormControl>
            </FormGroup>
            {/* <OverlayTrigger overlay={(<Tooltip id="tooltip-default-ownership">Plan on creating more content with this person? Check this box to automatically assign this ownership type to them for future agreements (you can always change their ownership type later).</Tooltip>)} placement="right">
              <FormGroup>
                <Checkbox ref="defaultOwnership">
                  Make this the default ownership type for this collaborator
                </Checkbox>
              </FormGroup>
            </OverlayTrigger> */}
          </Modal.Body>

          <Modal.Footer>
            <div className="actions">
              <Button bsStyle="link" onClick={() => this.close()}>
                cancel
              </Button>
              <button type="submit">Save</button>
            </div>
          </Modal.Footer>
        </Form>
      </Modal>
    );
  }
}

const mapStateToProps = (state) => ({
  fields: state.create.fields,
  roles: state.global.roles,
  ownershipTypes: state.global.ownershipTypes,
  members: state.users.members,
  profile: state.profile,
});

const mapDispatchToProps = (dispatch) => ({
  alert: (type, msg) => {
    dispatch(actions.alert(type, msg));
  },
  hideAlert: () => {
    dispatch(actions.hideAlert());
  },
});

export default connect(mapStateToProps, mapDispatchToProps)(CreateMember);



// WEBPACK FOOTER //
// src/components/Members/CreateMember.jsx